import React from 'react';
import { Link } from 'react-router-dom';

const NotFoundPage = () => {
  return (
    <div className="not-found-container">
      <h1>404 - THE PAGE CAN'T BE FOUND</h1>
      <Link to="/" className="home-link">GO TO HOMEPAGE</Link>
    </div>
  );
};

export default NotFoundPage;